/* eslint-disable camelcase */
import en from "./en.json";
import en_US from "./en_US.json";
import it from "./it.json";
import es from "./es.json";
import de from "./de.json";
import pt from "./pt.json";
import fr from "./fr.json";
import ga from "./ga.json";
import uk from "./uk.json";
import zh from "./zh.json";
import ja from "./ja.json";

export { en, en_US, it, es, de, pt, fr, ga, uk, zh, ja };
